
import Electricity from "../../../assets/outline/Electricity.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ElectricityIcon({ className, dataTestid = "ElectricityIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Electricity data-testid={dataTestid} className={classes} {...rest} />
  );
}
